import type { ReactNode } from 'react';
import React from 'react';
import type { CSSProperties } from 'styled-components';
import styled from 'styled-components';

import type { AlignmentType } from '../layout.constants';
import { Alignment } from '../layout.constants';

export type Props = {
  children: ReactNode;
  style?: CSSProperties & Record<string, string>;
  vAlign: AlignmentType;
  hAlign: AlignmentType;
  noWrap: boolean | null;
  role?: string | undefined;
  id?: string;
};

// eslint-disable-next-line rover/prefer-kibble-components
export const HorizontalWrapper = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: ${(props): string => props.hAlign.toString()};
  align-items: ${(props): string => props.vAlign.toString()};
  flex-wrap: ${(props): string => (props.noWrap ? 'nowrap' : 'wrap')};
  flex-shrink: 0;
`;

const HorizontalLayout = (props: Props): JSX.Element => (
  <HorizontalWrapper {...props}>{props.children}</HorizontalWrapper>
);

HorizontalLayout.defaultProps = {
  style: {},
  vAlign: Alignment.START,
  hAlign: Alignment.START,
  noWrap: false,
};

export default HorizontalLayout;
